import { IReferral } from '@sales-center/common'
import { SetReferral } from './typings'

export const setReferralActionCreator = (
  payload: IReferral | null,
): SetReferral => ({
  type: 'referrals/setReferral',
  payload,
})
